import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetrics = ({ metrics }) => {
  const MetricCard = ({ title, value, change, icon, color = 'text-card-foreground' }) => (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-2">
        <div className={`w-8 h-8 rounded-md flex items-center justify-center ${
          color?.includes('success') ? 'bg-success/10' :
          color?.includes('error') ? 'bg-error/10' :
          color?.includes('warning') ? 'bg-warning/10' :
          'bg-primary/10'
        }`}>
          <Icon 
            name={icon} 
            size={16} 
            className={color?.includes('success') ? 'text-success' :
              color?.includes('error') ? 'text-error' :
              color?.includes('warning') ? 'text-warning' :
              'text-primary'
            }
          />
        </div>
        {change && (
          <span className={`text-xs font-medium ${
            change > 0 ? 'text-success' : change < 0 ? 'text-error' : 'text-muted-foreground'
          }`}>
            {change > 0 ? '+' : ''}{change}%
          </span>
        )}
      </div>
      <p className="text-xs text-muted-foreground mb-1">{title}</p>
      <p className={`text-lg font-semibold ${color}`}>{value}</p>
    </div>
  );

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-card-foreground">Signal Performance</h3>
        <div className="flex items-center space-x-2 text-xs text-muted-foreground">
          <Icon name="Calendar" size={14} />
          <span>Last 30 days</span>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <MetricCard
          title="Overall Accuracy"
          value={`${metrics?.accuracy}%`}
          change={metrics?.accuracyChange}
          icon="Target"
          color="text-success"
        />
        <MetricCard
          title="Average Return"
          value={`${metrics?.averageReturn}%`}
          change={metrics?.returnChange}
          icon="TrendingUp"
          color="text-success"
        />
        <MetricCard
          title="Total Signals"
          value={metrics?.totalSignals?.toLocaleString()}
          change={metrics?.signalsChange}
          icon="Zap"
          color="text-primary"
        />
        <MetricCard
          title="Win Rate"
          value={`${metrics?.winRate}%`}
          change={metrics?.winRateChange}
          icon="Award"
          color="text-warning"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="TrendingUp" size={16} className="text-success" />
            <span className="text-sm font-medium text-card-foreground">Buy Signals</span>
          </div>
          <p className="text-lg font-semibold text-success">{metrics?.buySignals}</p>
          <p className="text-xs text-muted-foreground">Accuracy: {metrics?.buyAccuracy}%</p>
        </div>

        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="TrendingDown" size={16} className="text-error" />
            <span className="text-sm font-medium text-card-foreground">Sell Signals</span>
          </div>
          <p className="text-lg font-semibold text-error">{metrics?.sellSignals}</p>
          <p className="text-xs text-muted-foreground">Accuracy: {metrics?.sellAccuracy}%</p>
        </div>

        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Minus" size={16} className="text-warning" />
            <span className="text-sm font-medium text-card-foreground">Hold Signals</span>
          </div>
          <p className="text-lg font-semibold text-warning">{metrics?.holdSignals}</p>
          <p className="text-xs text-muted-foreground">Accuracy: {metrics?.holdAccuracy}%</p>
        </div>
      </div>
    </div>
  );
};

export default PerformanceMetrics;